import React from "react";
import styles from "./MatchRowOverlay.scss";

class MatchRowOverlay extends React.Component {
  render() {
    const { positionText, companyText, id, onCancel, onSuccess } = this.props;

    return (
      <div className={styles.overlay}>
        <div className={styles.overlayRow}>
          <div className={styles.rejectText}>
            Are you sure you want to reject the match, {positionText} at{" "}
            {companyText}?
          </div>

          <button className={styles.cancelButton} onClick={onCancel}>
            {" "}
            No{" "}
          </button>
          <button
            className={styles.rejectButton}
            onClick={() => {
              onSuccess(id);
            }}
          >
            {" "}
            Yes{" "}
          </button>
        </div>
      </div>
    );
  }
}

export default MatchRowOverlay;



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/matches/components/matchRowOverlay/MatchRowOverlay.js